import { QueryStatus } from 'src/types'
import { OperacionCorporate } from '../types/types'
import { useEffect, useState } from 'react'
import { HttpCorporate } from '../api/httpCorporate'

export const useOperacionCorporate = (idOperacion: number) => {
    const [status, setStatus] = useState<QueryStatus>(QueryStatus.Idle)
    const [operacion, setOperacion] = useState<OperacionCorporate>()

    useEffect(() => {
        setStatus(QueryStatus.Loading)

        HttpCorporate.get(idOperacion)
            .then(data => {
                setOperacion(data)
                setStatus(QueryStatus.Success)
            })
            .catch(() => setStatus(QueryStatus.Error))
    }, [idOperacion])

    return { status, operacion }
}
